import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./StudentIdCard4.css";

export default function StudentIdCard4({ data, batch }) {
    const [setting, setSetting] = useState({});

    useEffect(() => {
        try {
            const savedSetting = localStorage.getItem("setting");

            if (savedSetting) {
                setSetting(JSON.parse(savedSetting));
            }
        } catch (error) {
            console.error("Setting parse error:", error);
        }
    }, []);

    const student = data?.student_info || {};

    const fullAddress = [
        student?.village,
        student?.district,
        student?.state,
    ]
        .filter(Boolean)
        .join(", ");

    const logoUrl = setting?.logo_img
        ? imgBaseUrl + setting.logo_img
        : "";

    const studentPhoto = student?.profile_picture
        ? imgBaseUrl + student.profile_picture
        : "/files/user.png";

    const signatureUrl = setting?.signature
        ? imgBaseUrl + setting.signature
        : "";

    return (
        <div
            className="student-id-card-final"
            style={{
                "--student-card-watermark": logoUrl
                    ? `url("${logoUrl}")`
                    : "none",
            }}
        >
            {/* =====================================================
                HEADER
            ====================================================== */}

            <div className="student-id-card-final__header">

                {/* SCHOOL LOGO */}
                <div className="student-id-card-final__logo">
                    {logoUrl && (
                        <img
                            src={logoUrl}
                            alt="School Logo"
                        />
                    )}
                </div>

                {/* SCHOOL INFORMATION */}
                <div className="student-id-card-final__school">

                    <h1>
                        {setting?.name || ""}
                    </h1>

                    <p className="student-id-card-final__address-line">
                        {setting?.village || ""}
                        {setting?.district
                            ? ` ${setting.district}`
                            : ""}
                        {setting?.state
                            ? ` ${setting.state}`
                            : ""}
                        {setting?.pin_code
                            ? `, ${setting.pin_code}`
                            : ""}
                    </p>

                    <p>
                        Contact : {setting?.mobile || ""}
                        {setting?.secondary_mobile
                            ? `, ${setting.secondary_mobile}`
                            : ""}
                    </p>

                    <p>
                        Email : {setting?.email || ""}
                    </p>

                </div>
            </div>


            {/* =====================================================
                HEADER DIVIDER
            ====================================================== */}

            <div className="student-id-card-final__header-line"></div>


            {/* =====================================================
                MAIN STUDENT AREA
            ====================================================== */}

            <div className="student-id-card-final__main">

                {/* ================= STUDENT DETAILS ================= */}

                <div className="student-id-card-final__details">

                    {/* STUDENT ID */}
                    <div className="student-id-card-final__row">

                        <div className="student-id-card-final__label">
                            STUDENT ID
                        </div>

                        <div className="student-id-card-final__colon">
                            :
                        </div>

                        <div className="student-id-card-final__value">
                            {student?.registration_no || "-"}
                        </div>

                    </div>


                    {/* NAME */}
                    <div className="student-id-card-final__row">

                        <div className="student-id-card-final__label">
                            Name
                        </div>

                        <div className="student-id-card-final__colon">
                            :
                        </div>

                        <div className="student-id-card-final__value">
                            {student?.name || "-"}
                        </div>

                    </div>


                    {/* FATHER NAME */}
                    <div className="student-id-card-final__row">

                        <div className="student-id-card-final__label">
                            Father's Name
                        </div>

                        <div className="student-id-card-final__colon">
                            :
                        </div>

                        <div className="student-id-card-final__value">
                            {student?.father_name || "-"}
                        </div>

                    </div>


                    {/* MOBILE */}
                    <div className="student-id-card-final__row">

                        <div className="student-id-card-final__label">
                            Mobile No
                        </div>

                        <div className="student-id-card-final__colon">
                            :
                        </div>

                        <div className="student-id-card-final__value">
                            {student?.phone || "-"}
                        </div>

                    </div>


                    {/* BATCH */}
                    <div className="student-id-card-final__row">

                        <div className="student-id-card-final__label">
                            Batch Name
                        </div>

                        <div className="student-id-card-final__colon">
                            :
                        </div>

                        <div className="student-id-card-final__value">
                            {batch?.title || "-"}
                        </div>

                    </div>


                    {/* HOSTEL */}
                    {String(student?.hostel_status).toLowerCase() ===
                        "yes" && (
                            <div className="student-id-card-final__row">

                                <div className="student-id-card-final__label">
                                    Hostel
                                </div>

                                <div className="student-id-card-final__colon">
                                    :
                                </div>

                                <div className="student-id-card-final__value">
                                    Yes
                                </div>

                            </div>
                        )}

                </div>


                {/* ================= STUDENT PHOTO ================= */}

                <div className="student-id-card-final__photo">

                    <img
                        src={studentPhoto}
                        alt="Student"
                    />

                </div>

            </div>


            {/* =====================================================
                ADDRESS
            ====================================================== */}

            <div className="student-id-card-final__student-address">

                <div className="student-id-card-final__address-label">
                    Address
                </div>

                <div className="student-id-card-final__address-colon">
                    :
                </div>

                <div className="student-id-card-final__address-value">

                    {fullAddress || "-"}

                    {student?.zipcode
                        ? ` - ${student.zipcode}`
                        : ""}

                </div>

            </div>


            {/* =====================================================
                BOTTOM DIVIDER
            ====================================================== */}

            {/* <div className="student-id-card-final__bottom-line"></div> */}


            {/* =====================================================
                ADMISSION DATE
            ====================================================== */}

            <div className="student-id-card-final__admission">

                Admission Date :{" "}

                {student?.admission_date
                    ? formatToDate(student.admission_date)
                    : "-"}

            </div>


            {/* =====================================================
                SIGNATURE
            ====================================================== */}

            <div className="student-id-card-final__signature">

                {signatureUrl && (
                    <img
                        src={signatureUrl}
                        alt="Authorized Signature"
                    />
                )}

                <div>
                    Auth. Signature
                </div>

            </div>

        </div>
    );
}